import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { t } from 'i18next';

export default function Tab2({ total }) {
    return (
        <div className="flex justify-between">
            <div className="flex space-x-2 items-center">
                <div className="text-xl font-bold">
                    {t('RList.RiskRegister')}
                </div>
                <Tooltip
                    placement="right"
                    overlayStyle={{ minWidth: '23%' }}
                    title={<div>{t('RA.TooltipTap2')}</div>}
                >
                    <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                        <ExclamationCircleOutlined />
                    </a>
                </Tooltip>
            </div>
            <div
                style={{ color: '#65707A' }}
                className="flex font-semibold items-center"
            >
                {t('TotalItems', { length: total })}
            </div>
        </div>
    );
}
